export class FeedbackTableRangeDates {
  dateBefore: number | null;
  dateAfter: number | null;
}
